(function ($, app, PageTemplates, Notifier) {
	var notifier = new Notifier({
		baseCls: 'notifier',
		theme: 'clean',
		types: ['popup', 'decisionPopup', 'notification', 'wait', 'error'],
		type: null,
		dialog: true,
		title: '',
		closeBtn: true,
		ms: false,
		hideOnClick: false,
		fadeInMs: 0,
		fadeOutMs: 0,
		position: 'center',
		zIndex: 10000
	});

	var dialog = {};

	dialog.decisionPopup = function (options) {

		options = $.extend({}, {
			type: 'decisionPopup',
			modal: true,
			closeBtn: false,
			hideOnOverlayClick: false,
			hideOnClick: false,
			hideOnEscape: false,
			buttons: []
		}, options);

		return notifier.notify(options);
	};

	dialog.popup = function (options) {

		options = $.extend({}, {
			type: 'popup',
			title: 'Info',
			modal: true,
			closeBtn: false,
			hideOnClick: true
		}, options);

		return notifier.notify(options);
	};

	dialog.error = function (options) {

		options = $.extend({}, {
			type: 'error',
			title: '',
			modal: true,
			closeBtn: false,
			hideOnClick: true
		}, options);

		return notifier.notify(options);
	};

	dialog.wait = function (options) {

		options = $.extend({}, {
			type: 'wait',
			hideOnEnter: false,
			hideOnEscape: false,
			hideOnClick: false,
			hideOnOverlayClick: false,
			message: PageTemplates.get('js_pleaseWait'),
			closeBtn: false,
			loader: true,
			modal: true,
			screenOpacity: 0.1
		}, options);

		return notifier.notify(options);
	};

	dialog.popdown = function (options) {

		options = $.extend({}, {
			type: 'warning',
			ms: null,
			closeBtn: false,
			hideOnOverlayClick: true,
			hideOnClick: false,
			hideOnEscape: false,
			buttons: [],
			position: 'top',
			fadeInMs: 500,
			fadeOutMs: 250,
			destroy: true,
			modal: false,
			screenOpacity: 0
		}, options);
		var popup = notifier.notify(options),
			eventClick = 'click.' + new Date().getTime();
		popup.$el.addClass('notifier-popdown');
		$('body > *').on(eventClick, function () {
			$('body > *').off(eventClick);
			popup.destroy();
		});
		return popup;
	};

	app.dialog = dialog;

})(jQuery, window.app, window.PageTemplates, Backbone.Notifier);